module.exports = __webpack_public_path__ + "static/media/StoreCreation.c7ec5a17.xlsx";